import logo from "@/assets/logo.png";
import { Button } from "@/components/ui/button";

interface FreePlanFooterProps {
    className?: string;
}

export function FreePlanFooterCta({ className = "" }: FreePlanFooterProps) {
    return (
        <div className={`border border-border rounded-lg p-4 flex flex-col sm:flex-row items-center justify-between gap-4 bg-card/50 mt-4 ${className}`}>
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 shrink-0">
                    <img src={logo} alt="RaffleKit Logo" className="w-full h-full object-contain rounded-md" />
                </div>
                <div className="text-left">
                    <span className="text-[9px] uppercase tracking-widest text-muted-foreground/80 font-medium block mb-0.5">Powered by</span>
                    <span className="font-heading font-bold text-foreground block text-sm leading-none">RaffleKit</span>
                    <span className="text-xs text-muted-foreground leading-tight mt-0.5 block">Dead simple giveaways for small businesses, brands, and creators.</span>
                </div>
            </div>
            <Button asChild size="sm" className="w-full sm:w-auto bg-primary text-primary-foreground border-0 shrink-0 font-medium shadow-sm transition-all hover:scale-105 hover:bg-primary hover:brightness-110">
                <a href="/" target="_blank" rel="noopener noreferrer">Get started for free</a>
            </Button>
        </div>
    );
}
